// Author thq
// Date 2024-06-07 16:44:40

class EmSppInventoryChangeIch {
    constructor({
                    id = null,
                    ichIdSpi = '',
                    ichChangeType = '',
                    ichChangeQuantity = '',
                    ichChangePrice = '',
                    ichDestination = '',
                    ichChangeDate = '',
                    ichRecorder = '',
                    ichIdBusiness = '',
                    ichComment = '',
                    ichAttachment = '',
                    ichAttachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.ichIdSpi = ichIdSpi;
        this.ichChangeType = ichChangeType;
        this.ichChangeQuantity = ichChangeQuantity;
        this.ichChangePrice = ichChangePrice;
        this.ichDestination = ichDestination;
        this.ichChangeDate = ichChangeDate;
        this.ichRecorder = ichRecorder;
        this.ichIdBusiness = ichIdBusiness;
        this.ichComment = ichComment;
        this.ichAttachment = ichAttachment;
        this.ichAttachmentList = ichAttachmentList;
    }
}

function newEntity() {
    return new EmSppInventoryChangeIch();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ichIdSpi',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.ichIdSpi',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiCodeSpa',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.spiCodeSpa',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiNameSpa',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.spiNameSpa',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ichChangeType',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.ichChangeType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '期初入库'},
                    {value: '1', text: '入库'},
                    {value: '2', text: '出库'},
                    {value: '3', text: '修改库存信息'},
                    {value: '4', text: '盘库'}
                ]
            }
        },
        {
            key: 'ichChangeQuantity',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.ichChangeQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ichUnit',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.ichUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ichChangePrice',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.ichChangePrice',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ichDestination',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.ichDestination',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ichChangeDate',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.ichChangeDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ichRecorder',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.ichRecorder',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ichRecorderName',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.ichRecorderName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ichComment',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.ichComment',
            sortable: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ichAttachmentList',
            label: 'label.em.spareparts.emSppInventoryChangeIch.grid.ichAttachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    ichIdSpiFilter: '',
    ichChangeTypeFilter: '',
    ichChangeQuantityFilter: '',
    ichChangePriceFilter: '',
    ichDestinationFilter: '',
    ichChangeDateRteFilter: '',
    ichChangeDateLteFilter: '',
    ichRecorderFilter: '',
    ichIdBusinessFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'ichIdSpiFilter',
        label: 'label.em.spareparts.emSppInventoryChangeIch.filter.ichIdSpi',
        disabled: false,
        form: {
            type: 'entityModalMultipleSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSparePartsInventorySpi'
        }
    },
    {
        key: 'ichChangeTypeFilter',
        label: 'label.em.spareparts.emSppInventoryChangeIch.filter.ichChangeType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '期初入库'},
                {value: '1', text: '入库'},
                {value: '2', text: '出库'},
                {value: '3', text: '修改库存信息'},
                {value: '4', text: '盘库'}
            ]
        }
    },
    {
        key: 'ichDestinationFilter',
        label: 'label.em.spareparts.emSppInventoryChangeIch.filter.ichDestination',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ichChangeDateRteFilter',
        label: 'label.em.spareparts.emSppInventoryChangeIch.filter.ichChangeDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ichChangeDateLteFilter',
        label: 'label.em.spareparts.emSppInventoryChangeIch.filter.ichChangeDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ichRecorderFilter',
        label: 'label.em.spareparts.emSppInventoryChangeIch.filter.ichRecorder',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'ichIdSpi',
        label: 'label.em.spareparts.emSppInventoryChangeIch.entity.ichIdSpi',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSparePartsInventorySpi'
            , correspondingField: 'id'
        }
    },
    {
        key: 'ichChangeType',
        label: 'label.em.spareparts.emSppInventoryChangeIch.entity.ichChangeType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '期初入库'},
                {value: '1', text: '入库'},
                {value: '2', text: '出库'},
                {value: '3', text: '修改库存信息'},
                {value: '4', text: '盘库'}
            ]
        }
    },
    {
        key: 'ichChangeQuantity',
        label: 'label.em.spareparts.emSppInventoryChangeIch.entity.ichChangeQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ichChangePrice',
        label: 'label.em.spareparts.emSppInventoryChangeIch.entity.ichChangePrice',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ichDestination',
        label: 'label.em.spareparts.emSppInventoryChangeIch.entity.ichDestination',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ichChangeDate',
        label: 'label.em.spareparts.emSppInventoryChangeIch.entity.ichChangeDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ichRecorder',
        label: 'label.em.spareparts.emSppInventoryChangeIch.entity.ichRecorder',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'ichComment',
        label: 'label.em.spareparts.emSppInventoryChangeIch.entity.ichComment',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ichAttachmentList',
        label: 'label.em.spareparts.emSppInventoryChangeIch.entity.ichAttachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'ichAttachment'
        }
    }
]

export {
    EmSppInventoryChangeIch, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
